

(function() {
  'use strict';

  const ExternalCheckout = {
    checkoutUrl: 'https://checkout.skinkceuticals.com/index.php',
    cookieName: 'cart_data',
    
    init: function() {
      this.bindCheckoutButton();
    },

    /**
     * Retorna a URL do cart.json baseado no domínio atual
     */
    getCartJsonUrl: function() {
      return `${window.location.origin}/cart.json`;
    },

    /**
     * Limpa dados null/undefined do objeto do carrinho
     */
    sanitizeCartData: function(cart) {
      if (!cart) return null;

      const sanitizeValue = (val) => {
        if (val === null || val === undefined) return '';
        return val;
      };

      const sanitizeItem = (item) => {
        return {
          id: sanitizeValue(item.id),
          quantity: sanitizeValue(item.quantity) || 0,
          title: sanitizeValue(item.title) || 'Produto',
          price: sanitizeValue(item.price) || 0,
          line_price: sanitizeValue(item.line_price) || 0,
          final_price: sanitizeValue(item.final_price) || 0,
          final_line_price: sanitizeValue(item.final_line_price) || 0,
          sku: sanitizeValue(item.sku),
          variant_id: sanitizeValue(item.variant_id),
          variant_title: sanitizeValue(item.variant_title),
          product_id: sanitizeValue(item.product_id),
          product_title: sanitizeValue(item.product_title) || sanitizeValue(item.title) || 'Produto',
          product_type: sanitizeValue(item.product_type),
          vendor: sanitizeValue(item.vendor),
          url: sanitizeValue(item.url),
          image: sanitizeValue(item.image),
          handle: sanitizeValue(item.handle),
          requires_shipping: item.requires_shipping || false,
          taxable: item.taxable || false,
          gift_card: item.gift_card || false
        };
      };

      return {
        token: sanitizeValue(cart.token),
        note: sanitizeValue(cart.note),
        attributes: cart.attributes || {},
        total_price: sanitizeValue(cart.total_price) || 0,
        total_weight: sanitizeValue(cart.total_weight) || 0,
        item_count: sanitizeValue(cart.item_count) || 0,
        items: Array.isArray(cart.items) ? cart.items.map(sanitizeItem) : [],
        requires_shipping: cart.requires_shipping || false,
        currency: sanitizeValue(cart.currency) || 'USD',
        items_subtotal_price: sanitizeValue(cart.items_subtotal_price) || 0,
        original_total_price: sanitizeValue(cart.original_total_price) || 0,
        image: sanitizeValue(cart.image),
        total_discount: sanitizeValue(cart.total_discount) || 0,
        shop_domain: window.location.hostname
      };
    },

    fetchCartData: async function() {
      try {
        const response = await fetch(this.getCartJsonUrl());
        
        if (!response.ok) {
          throw new Error('Erro ao buscar cart.json');
        }
        
        const cartData = await response.json();
        return this.sanitizeCartData(cartData);
        
      } catch (error) {
        console.error('External Checkout: Erro ao buscar dados do carrinho', error);
        return null;
      }
    },

    saveCartCookie: function(cartData) {
      try {
        const cartJson = JSON.stringify(cartData);
        const cartBase64 = btoa(unescape(encodeURIComponent(cartJson)));
        
        const expires = new Date();
        expires.setTime(expires.getTime() + (1 * 60 * 60 * 1000));
        
        document.cookie = `${this.cookieName}=${cartBase64}; expires=${expires.toUTCString()}; path=/; SameSite=Lax`;
        
        return cartBase64;
      } catch (error) {
        console.error('External Checkout: Erro ao salvar cookie', error);
        return null;
      }
    },

    buildCheckoutUrl: function(cartData) {
      if (!cartData) {
        console.error('External Checkout: Dados do carrinho inválidos');
        return null;
      }
      
      try {
        const cartJson = JSON.stringify(cartData);
        const cartBase64 = btoa(unescape(encodeURIComponent(cartJson)));
        
        return `${this.checkoutUrl}?cart=${encodeURIComponent(cartBase64)}`;
      } catch (error) {
        console.error('External Checkout: Erro ao construir URL', error);
        return null;
      }
    },

    bindCheckoutButton: function() {
      const checkoutBtn = document.querySelector('[data-external-checkout]');
      
      if (!checkoutBtn) {
        console.warn('External Checkout: Botão de checkout não encontrado');
        return;
      }

      const originalText = checkoutBtn.textContent;

      checkoutBtn.addEventListener('click', async (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        checkoutBtn.disabled = true;
        checkoutBtn.style.opacity = '0.7';
        checkoutBtn.textContent = 'Processando...';
        
        try {
          const cartData = await this.fetchCartData();
          
          if (!cartData) {
            throw new Error('Não foi possível obter dados do carrinho');
          }

          this.saveCartCookie(cartData);

          const checkoutUrl = this.buildCheckoutUrl(cartData);
          
          if (checkoutUrl) {
            window.location.href = checkoutUrl;
          } else {
            throw new Error('Não foi possível construir a URL do checkout');
          }
          
        } catch (error) {
          console.error('External Checkout:', error);
          alert('Erro ao processar checkout. Tente novamente.');
          
          checkoutBtn.disabled = false;
          checkoutBtn.style.opacity = '1';
          checkoutBtn.textContent = originalText;
        }
      });

      console.log('External Checkout: Inicializado com sucesso');
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      ExternalCheckout.init();
    });
  } else {
    ExternalCheckout.init();
  }

})();
